import { MotionSensorIcon } from './MotionSensorIcon';

/**
 * author: Simran
 * id 2607909D-AA27-448A-B0E5-E5898790414A
 * name motion-sensor
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/motion-sensor.svg
 * tags
 * - Home Automation 
 */
export const MotionDetectorIcon = MotionSensorIcon;
export default MotionDetectorIcon